import React, { HTMLProps } from 'react';
import classNames from 'classnames';

import styles from './ProductCardDetails.module.scss';

type PropsType = HTMLProps<HTMLDivElement>;

export default function ProductCardDetails({
  className,
  ...rest
}: PropsType): JSX.Element {
  return <div className={classNames(styles.container, className)} {...rest} />;
}
